import React = require("react");
import { cloneDeep } from "lodash";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../model/state-models";
import { Category, Filters } from "../model/search-base-model";
import { emptyCategory } from "../factories/category-factory";
import { setFilter } from "../slice/search-slice";
import {
  FormControl,
  InputLabel,
  makeStyles,
  Theme,
} from "@material-ui/core";

interface DropdownFilterProps {
  categoryName: string;
  label: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 140,
  },
}));

export function DropdownFilter(props: DropdownFilterProps) {
  const { categoryName, label } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [productType, setProductType] = React.useState("");
  const categories = useSelector<AppState<any>, Category[]>(
    (state) => state?.searchState?.categories[categoryName]
  );
  const withEmpty = [emptyCategory]?.concat(categories);
  const filters = useSelector<AppState<any>, Filters>(
    (state) => state?.searchState?.filters
  );

  const onSelect = (evt) => {
    const { value } = evt?.target;
    const existing: Category[] = filters[categoryName];
    const category = {
      id: value,
      value,
      displayText: value,
    };
    if (existing) {
      filters[categoryName] = [category];
      const deepClone = cloneDeep(filters);
      dispatch(setFilter(deepClone));
    } else {
      const newFilters = filters || {};
      newFilters[categoryName] = [category];
      const deepClone = cloneDeep(newFilters);
      dispatch(setFilter(deepClone));
    }
    setProductType(value);
  };
  return (
    <FormControl className={classes.formControl}>
      <InputLabel id={`${categoryName}-label`}>{label}</InputLabel>
      <Select
        labelId={`${categoryName}-label`}
        id={categoryName}
        value={productType}
        label={label}
        onChange={onSelect}
      >
        {withEmpty?.map((c, idx) => (
          <MenuItem key={`${idx}-select-value`} value={c?.value}>
            {c?.displayText}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
